// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__AZkSP","log":"ModalInventoryLogs_log__3R0m7","date":"ModalInventoryLogs_date__3v0ey","userName":"ModalInventoryLogs_userName__1x_6O"};